module.exports = __webpack_public_path__ + "static/media/stofferingen-06.bd0e3ed8.jpg";